import React from 'react';
import { useTranslation } from 'react-i18next';

import { LandingLayout } from 'components/Landing/LandingLayout';

interface DescriptionProps {
  description: string;
}

const Description: React.FC<DescriptionProps> = ({ description }) => {
  const { t } = useTranslation();

  if (!description) {
    return null;
  }

  return (
    <>
      <LandingLayout.ContentHeading>
        {t('Description')}
      </LandingLayout.ContentHeading>
      <LandingLayout.ContentText>{description}</LandingLayout.ContentText>
    </>
  );
};

export default Description;
